import instance from '@/jmHttp/index';
import { user, login } from '@/jmHttp/interface';

/**
 * 根据id编辑成员偏好设置
 */
export const saveUserPreference = (data, config = {}) => {
  return instance.post(user.updateUserPreference, data, config);
};

/**
 * 保存偏好设置
 */
export const updateUserPreference = (data, config = {}) => {
  return instance.post(user.saveUserPreference, data, config);
};

/**
 * 查询指定类型的成员偏好设置
 */
export const getUserPreferenceList = async (data, config = {}) => {
  const result = await instance.post(user.getUserPreferenceList, data, config);
  if (!result?.data) {
    throw new Error('getUserPreferenceList result.data 为空');
  }

  return result.data;
};

// 获取角色菜单
export const getUserCustomMenu = async (data, config) => {
  return await instance.post(user.getUserCustomMenu, data, config);
};

// 重置为系统默认菜单
export const resetCustomMenu = async (data, config = {}) => {
  return await instance.post(user.resetCustomMenu, data, config);
};

// 设置默认打开菜单
export const setDefaultMenu = async (data, config = {}) => {
  return await instance.post(user.setDefaultMenu, data, config);
};

// 保存用户自定义菜单
export const saveCustomMenu = async (data, config = {}) => {
  return await instance.post(user.saveCustomMenu, data, config);
};

// 点击新菜单
export const clickNewMenu = async (data, config = {}) => {
  return await instance.post(user.clickNewMenu, data, config);
};

// 查询当前用户需要隐藏的菜单编码列表
export const getHiddenMenuCodes = async (data = {}, config = {}) => {
  return await instance.post(user.getHiddenMenuCodes, data, config);
};

export const getRoleModule = async (data, config) => {
  return await instance.post(login.getRoleModule, data, {
    ...config,
    defaultConfig: {
      bodyType: 'form'
    }
  });
};

// 获取用户信息（进门）
export const getUserInfo = async (data, config) => {
  return await instance.post(login.getUserInfo, data, {
    ...config,
    bodyType: 'form',
    defaultConfig: {
      bodyType: 'form'
    }
  });
};
